"use client"

import { useState, useEffect } from "react"
import styled from "styled-components"
import clientefeliz from "../assets/cliente.png";
import clientefeliz2 from "../assets/clientefeliz2.png";
import clientefeliz3 from "../assets/clientefeliz3.png";
import clientefeliz4 from "../assets/clientefeliz4.jpeg";
import clientefeliz5 from "../assets/clientefeliz5.jpeg";
import clientefeliz6 from "../assets/clientefeliz15.jpg";
import clientefeliz7 from "../assets/jorge_alberto_zapata_vazquez.jpg";
import clientefeliz8 from "../assets/brayan_restrepo.jpg";
import clientefeliz9 from "../assets/luis_albeiro_mera.jpg";
import clientefeliz10 from "../assets/Jhon Pachon.jpg";
import clientefeliz11 from '../assets/clientefeliz11.jpg';
import clientefeliz12 from '../assets/clientefeliz12.jpg';
import clientefeliz13 from '../assets/clientefeliz13.jpg';
import clientefeliz14 from '../assets/clientefeliz14.jpg';


const SliderContainer = styled.div`
  margin: 200px auto;
  position: relative;
  max-width: 1280px;
  padding: 0 20px;

  @media (max-width: 768px) {
    margin: 100px auto;
  }
`

const SliderContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 40px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
    text-align: center;
    align-items: center;
  }
`

const TestimonialText = styled.p`
  margin-bottom: 10px;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: #fff;
  line-height: 1.6;
`

const Divider = styled.div`
  width: 120px;
  height: 2px;
  background: linear-gradient(to right, red 33%, white 33%, white 66%, green 66%);
  margin: 15px 0;

  @media (max-width: 768px) {
    margin: 15px auto;
  }
`

const Author = styled.h2`
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: #fff;
  margin-bottom: 5px;
`

const Location = styled.span`
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  color: #fff;
`

const ImageContainer = styled.div`
  width: 50%;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 500px;
  }
`

const TestimonialImage = styled.img`
  width: 100%;
  height: 500px;
  object-fit: contain;

  @media (max-width: 768px) {
    height: 300px;
  }
`

const SliderClientes = () => {
  const [currentSlide, setCurrentSlide] = useState(0)
  const testimonials = [
    {
        text: "Excelente Bicicleta 🤩🤩🤩🤩.",
        author:"Valeria Rivera Gonzalez",
        location: "Bogotá",
        image: clientefeliz14
    },
    {
        text: "Explorar el mundo del ciclismo ha sido una experiencia increíble. Desarrollar nuevos intereses es fundamental para nutrir nuestra vida y expandir nuestros horizontes. ¡Es importante salir de la zona de confort y probar actividades que nos desafíen y nos llenen de energía! ¿Cuál es tu próxima aventura?",
        author: "Fredy Certain",
        location: "Bogotá",
        image: clientefeliz12
    },
    {
        text: "Día de rodada con mi esposita, con nuestras bicis java, excelentes bicis, gracias java colombia",
        author: "Oscar Alexander Guevara Muñoz",
        location: "Bogotá",
        image: clientefeliz13
    },
    {
        text: "Son personas muy responsables, ya he adquirido tres bicicletas con Java Colombia, todas llegan en perfecto funcionamiento, cabe destacar que soy de Venezuela",
        author: "Delvis Garcia",
        location: "Venezuela",
        image: clientefeliz11
    },
    {
        text: "Silurio TOP 6 colmó de manera satisfactoria mis expectativas. Rode mis primeros 42 kms adaptándome a está maravillosa máquina. En cuanto al cumplimiento en tiempos desde compra a entrega, excelente. Desde Ipiales Nariño un saludo",
        author: "Willian Nieto",
        location: "Ipiales, Nariño",
        image: clientefeliz
    },
    {
        text: "JAVA Siluro Top 6!!! Excelente maquina desde la primera rodada hasta ahora más de 500kms sin ningún problema. Muy ágil y compacta.",
        author: "Ricardo Castillo",
        location: "Bogotá, Cundinamarca",
        image: clientefeliz2
    },
    {
        text: "Día de rodada con mi esposita, con nuestras bicis java, excelentes bicis, gracias java colombia",
        author: "Oscar Guevara",
        location: "Pereira",
        image: clientefeliz3
    },
    {
        author: "Giovvany Saavedra",
        text: "Buena bicicleta, muy hermosa y confiable los vendedores.",
        image: clientefeliz6,
        location: "Bogotá" 
    },
    {
        author: "Jorge Alberto Zapata Vázquez",
        text: "La cicla excelente cumplió con las expectativas, valió la pena haber esperado para que llegara.",
        image:  clientefeliz7,
        location: "Paso los Caracoles, Chile Argentina"
    },
    {
        author: "Brayan Restrepo",
        text: "Muy bonitas las bicis, 10 de 10 la atención.",
        image: clientefeliz8,
        location: "Bogotá"
    },
    {
        author: "Luis Albeiro Mera",
        text: "Excelente bicicleta, además excelente servicio, muchas gracias.",
        image: clientefeliz9,
        location: "Jumbo Valle"
    },

    {
        author: "John Pachon",
        text: "Buenas bicicletas marca garantía",
        image: clientefeliz10,
        location: "Bogotá"
    }
    // Puedes agregar más testimonios aquí.
];
  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide + 1) % testimonials.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide - 1 + testimonials.length) % testimonials.length)
  }

  useEffect(() => {
    const intervalId = setInterval(nextSlide, 5000)
    return () => clearInterval(intervalId)
  }, []) // Removed nextSlide from dependencies

  return (
    <SliderContainer>
      <SliderContent>
        <TextContent>
          <TestimonialText>{testimonials[currentSlide].text}</TestimonialText>
          <Divider />
          <Author>{testimonials[currentSlide].author}</Author>
          <Location>{testimonials[currentSlide].location}</Location>
        </TextContent>
        <ImageContainer>
          <TestimonialImage src={testimonials[currentSlide].image || "/placeholder.svg"} alt="Testimonio" />
        </ImageContainer>
      </SliderContent>
    </SliderContainer>
  )
}

export default SliderClientes
